import { useCallback, useState } from 'react';

import { Optional } from 'chaika-frontend-types/frontend-cms';

interface UseRecurringSubscriptionTerms {
    billingAmount: Optional<number>;
    setBillingAmount(billingAmount: number): void;

    billingAmountDuration: Optional<string>;
    setBillingAmountDuration(billingAmountDuration?: string): void;

    isUsedSpecialTerms: boolean;
    toggleIsUsedSpecialTerms(): void;
}

export const useRecurringSubscriptionTerms = (): UseRecurringSubscriptionTerms => {
    const [billingAmount, setBillingAmount] = useState<Optional<number>>();
    const [billingAmountDuration, setBillingAmountDuration] = useState<Optional<string>>();
    const [isUsedSpecialTerms, setIsUsedSpecialTerms] = useState<boolean>(false);

    const toggleIsUsedSpecialTerms = useCallback(() => {
        setIsUsedSpecialTerms(isUsed => !isUsed);
    }, [setIsUsedSpecialTerms]);

    return {
        billingAmount,
        setBillingAmount,

        billingAmountDuration,
        setBillingAmountDuration,

        isUsedSpecialTerms,
        toggleIsUsedSpecialTerms,
    };
};
